module.exports = __webpack_public_path__ + "img/cobbl.984dd310.png";